/* eslint-disable no-plusplus */
/**
 * Carousel JavaScript
 *
 * This file defines behaviors of
 * the Carousel block.
 */

// for each grid item
document.querySelectorAll('.popup-grid__item')?.forEach((item) => {
	// if we have a popup
	const popup = item.querySelector('.popup');
	if (popup) {
		// create a unique id
		const id = `popup-grid-${++window.aquamin.disambiguate}`;
		popup.setAttribute('id', id);
		// link existing buttons to this id
		item.querySelectorAll('a[href="#popup"')?.forEach((button) => {
			button.setAttribute('href', `#${id}`);
		});
		// link media to this id
		const mediaWrap = item.firstElementChild;
		const media = mediaWrap.firstElementChild;
		const a = document.createElement('a');
		a.setAttribute('href', `#${id}`);
		a.setAttribute('aria-label', mediaWrap.dataset.label);
		a.classList.add('popup-grid__media');
		a.append(media);
		item.firstElementChild.replaceWith(a);
	}
});
